import { COURSE_LEARNING } from '@components/locale-pages/home/courses'
import { FastlyImage } from '@components/common/image'
import { Trans } from '@lingui/macro'
import BookFreeClassBtn from '@components/common/book-free-class-btn'

type Props = {
  title?: JSX.Element
  description?: JSX.Element
  courseName?: string
  urlQuery?: string
}

const ContentCard = ({ title, description, courseName, urlQuery }: Props) => {
  const courseLearning = courseName ? COURSE_LEARNING[courseName] : null
  return (
    <div className="flex flex-col text-grey container mx-auto my-10 lg:px-3 py-5">
      <h2 className="text-2xl font-600 mb-4 leading-tight">{title}</h2>
      {description && <p className="lg:text-lg mb-4">{description}</p>}
      {courseName && (
        <div className="flex flex-col gap-4 mt-4">
          {courseLearning.map((e, i) => (
            <div className="p-4 shadow-md rounded-md" key={i}>
              <div className="flex items-center gap-4 mb-3">
                <div>
                  {
                    <FastlyImage
                      src={`/images/courses/icons/${e.image}.png`}
                      alt={e.title}
                      webpSrc={`/images/courses/icons/${e.image}.webp`}
                      width={40}
                      height={40}
                      className="h-10 w-10 object-contain"
                    />
                  }
                </div>
                <h3 className="text-lg md:text-2xl font-500 leading-tight">
                  <Trans>{e.title}</Trans>
                </h3>
              </div>
              <span className="block">
                <Trans>{e.description}</Trans>
              </span>
            </div>
          ))}
        </div>
      )}
      {urlQuery && (
        <span className="mx-auto w-full md:max-w-xs mt-12 text-center">
          <BookFreeClassBtn query={urlQuery} />
        </span>
      )}
    </div>
  )
}

export default ContentCard
